import { Link } from 'wouter'
import logo from '@/assets/q20-logo4.png'

export const NavHomeButton = ({
  hardReload,
  logoWidth,
  disabled,
  href,
}: {
  hardReload?: boolean
  logoWidth?: number
  disabled?: boolean
  href?: string
}) => {
  return (
    <Link
      href={href || (disabled ? '~#' : '~/')}
      onMouseUp={() => {
        if (hardReload && !disabled) {
          window.location.href = '/'
        }
      }}
    >
      <img
        src={logo}
        style={{ width: logoWidth ?? 50, maxWidth: logoWidth ?? 50 }}
      />
    </Link>
  )
}
